import { render, staticRenderFns } from "./LegajoDashboard.vue?vue&type=template&id=22c0ea9a"
import script from "./LegajoDashboard.vue?vue&type=script&lang=js"
export * from "./LegajoDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports